<template>
  <div>
    <h2>Purchase Summary</h2>

    <table class="tdesk-table">
      <tbody>
      <tr v-for="item in items" class="align-top">
        <td class="nowrap">
          <strong>
            {{item.quantity}} x
          </strong>
        </td>
        <td>{{item.description}}</td>
        <td class="nowrap">
          <strong>
            <span v-if="item.price < 0">-${{parseFloat(item.price * -1).toFixed(2)}}</span>
            <span v-else>${{parseFloat(item.price).toFixed(2)}}</span>
          </strong>
        </td>
      </tr>
      <tr>
        <td class="nowrap"><strong>Total</strong></td>
        <td></td>
        <td class="nowrap"><strong>${{parseFloat(totalPrice).toFixed(2)}}</strong></td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    props: {
      items: {required: true, type: Array},
      totalPrice: { required: true }
    }
  }
</script>